import { FileUpload, PreviewFile } from '../../../components/files/FilesUpload';
import { Plus } from 'lucide-react';

const MAX_FILES = 5;

export default function FormServicoImages({ value, setValue, disabled = false }: any) {
    return (
        <FileUpload key={`${!!value.length}`} value={value} setValue={setValue} disabled={disabled}>
            {({ fileData, handleChange, removeFile, inputRef, loading }) => {
                const handleFileChange = (e: any) => {
                    const selectedFiles: any = Array.from(e.target.files || []);

                    handleChange(selectedFiles.slice(0, MAX_FILES - fileData.length));
                };

                return (
                    <div className="p-4">
                        <div className="flex flex-wrap items-center gap-2" onClick={(e) => e.preventDefault()}>
                            {fileData.map((file) => (
                                <PreviewFile key={file.id} fileData={file} onRemove={removeFile} />
                            ))}
                            {fileData.length < MAX_FILES && (
                                <>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={inputRef}
                                        multiple
                                        disabled={loading}
                                        className="hidden"
                                        onChange={handleFileChange}
                                    />
                                    <button
                                        type="button"
                                        className="sf-thumb !h-20 !w-20 !text-xl"
                                        disabled={loading}
                                        aria-label="Adicionar imagem"
                                        onClick={() => inputRef.current?.click()}
                                    >
                                        <Plus aria-hidden />
                                    </button>
                                </>
                            )}
                        </div>
                        <p className="mt-2 text-xs text-base-content/55">
                            {fileData.length} de {MAX_FILES} imagens
                        </p>
                    </div>
                );
            }}
        </FileUpload>
    );
}
